import _objectSpread from "D:/workspace/js/hotfix/sunway-web-ui/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import "core-js/modules/es.number.constructor.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
import LinkItem from '@/sunway/link-item/link-item';
import { mapState } from 'vuex';
export default {
  props: {
    options: Object,
    propValue: [Number, String],
    formData: Object
  },
  components: {
    LinkItem: LinkItem
  },
  computed: _objectSpread({}, mapState(['form'])),
  data: function data() {
    var _this$options$readonl;

    return {
      readonly: (_this$options$readonl = this.options.readonly) !== null && _this$options$readonl !== void 0 ? _this$options$readonl : false
    };
  },
  mounted: function mounted() {
    this.form.editorManager[this.options.field] = this.$refs.editor;
  },
  methods: {
    changeHandle: function changeHandle(value) {
      this.$emit('change', this.options.field, value);
    },
    itemClickHandle: function itemClickHandle(itemValue, item) {
      var _this$options$onItemC;

      (_this$options$onItemC = this.options.onItemClick) === null || _this$options$onItemC === void 0 ? void 0 : _this$options$onItemC.call(this.form, itemValue, item);
    }
  }
};